import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from '@/Components/ui/tabs';
import { cn } from '@/lib/utils';

export default function StatsTabs() {
  const [activeTab, setActiveTab] = useState('Tech Industry Stats');
  
  const allTabs = [
    'Open Tech Jobs', 
    'Big Tech Hiring', 
    'Top Tech Company', 
    'Top Tech Location', 
    'Hottest Companies by Sector',
    'Hottest Companies by Investor', 
    'Tech Industry Stats', 
    'Remote Index', 
    'Job Reports'
  ];

  return (
    <div className="mt-[74px] w-full">
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className={cn(
          "inline-flex h-auto items-center justify-start rounded-lg bg-transparent p-1 text-muted-foreground",
          "flex-wrap gap-[25px] w-full"
        )}>
          {allTabs.map((tab) => (
            <TabsTrigger
              key={tab}
              value={tab}
              className={cn(
                "rounded-lg border border-muted-foreground/30 px-2.5 py-2.5",
                "bg-transparent text-foreground text-xl font-medium tracking-wide whitespace-nowrap",
                "hover:bg-accent transition-colors",
                "data-[state=active]:bg-gradient-to-br data-[state=active]:from-[#1a37f5] data-[state=active]:to-[#0074ff]",
                "data-[state=active]:border-none data-[state=active]:text-white"
              )}
            >
              {tab}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
}
